export interface ClergyBioChurchReportingFormModel {
    race_ethnicities: string[];
    sexual_orientations: string[];
    gender_identities: string[];
    ethnicitySpecify: string;
    sexualSpecify: string;
    genderSpecify: string;
}


export const ethnicityOptions = [
    {
        value: 'American Indian or Alaska Native', label: 'American Indian or Alaska Native',
    },
    {
        value: 'Asian', label: 'Asian',
    },
    {
        value: 'Black or African American', label: 'Black or African American',
    },
    {
        value: 'Hispanic or Latino', label: 'Hispanic or Latino',
    },
    {
        value: 'Native Hawaiian or Other Pacific Islander', label: 'Native Hawaiian or Other Pacific Islander',
    },
    {
        value: 'White', label: 'White',
    },
    {
        value: 'Self-describe', label: 'Other race/ethnicity',
    },
];

export const sexualOrientationOptions = [
    {
        value: 'Asexual', label: 'Asexual',
    },
    {
        value: 'Bisexual', label: 'Bisexual',
    },
    {
        value: 'Gay', label: 'Gay',
    },
    {
        value: 'Heterosexual', label: 'Heterosexual',
    },
    {
        value: 'Lesbian', label: 'Lesbian',
    },
    {
        value: 'Pansexual', label: 'Pansexual',
    },
    {
        value: 'Unsure', label: 'Unsure',
    },
    {
        value: 'Self-describe', label: 'Self-describe',
    },
];

export const genderIdentityOptions = [
    {
        value: 'Male', label: 'Male',
    },
    {
        value: 'Female', label: 'Female',
    },
    {
        value: 'Non-binary', label: 'Non-Binary',
    },
    {
        value: 'Self-describe', label: 'Self-describe',
    },
];